import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    protected breadcrumbs:Array<any> = [];
    public list:Array<any> = [];
    protected urlToFind:string = "";
    protected deepResult: any;

    constructor( protected router: Router){
    }

    getBreadcrumbs(res) {
        this.urlToFind = this.router.url ;
        this.traverseBreadcrumbs(res[0], [], this);
        return this.list;
    }
    protected traverseBreadcrumbs(node, path, that) {
        if(!path)
            path = [];
        if(node.children) {
            path.push(
                {
                    name:node.name,
                    url: node.url,
                }
            );
            node.children.forEach(function(item) {
                if(item.url === that.urlToFind) {
                    path.push(
                        {
                            name:item.name,
                            url: item.url,
                        }
                    );
                    that.list.push(path);
                }
                if(that.findDeep(item, {url: that.urlToFind})) {
                    that.traverseBreadcrumbs(item, path.slice(), that);
                }
            });
        }
    }

    protected traverse(value, attrs, that, treeRootId?) {
        let result;
        if (value) {
            if(value.children)
                for(let val of value.children) {
                    if (val.url) {
                        let checkedVal = false;
                        if(Array.isArray(attrs)) {
                            if (that.match(val.url, attrs)) {
                                checkedVal = true;
                            }
                        }
                        else if(attrs.hasOwnProperty('url')){
                            if(val.url === attrs.url) {
                                checkedVal = true;
                            }
                        }
                        else {
                            if(val.url === attrs) {
                                checkedVal = true;
                            }
                        }
                        if(checkedVal) {
                            result = val;
                            break;
                        }
                    }
                    if (_.isObject(val) || _.isArray(val)) {
                        that.traverse(val, attrs, that);
                    }
                }
            if(result) {
                that.deepResult = result;
                return result;
            }
        }
    }

    public findDeep(haystack, needle, treeRootId?) {
        this.deepResult = {};
        this.traverse(haystack, needle, this, treeRootId);
        return this.deepResult;
    }
}
